export default httpClient => ({
  save: async ({ name, email, password, status, token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.post('/usuarios', {
      name,
      email,
      password,
      status,
    }, { headers })
    return {
      data: response.data,
    }
  },
  update: async ({ id, name, email, password, token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.patch('/usuarios/' + id, {
      id,
      name,
      email,
      password
    }, { headers });
    return {
      data: response.data
    }
  },
  getById: async ({ id, token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.get('/usuarios/' + id, { headers });
    return {
      data: response.data
    }
  },
  getAll: async ({ token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.get('/usuarios', { headers });
    return { data: response.data }
  },
  delete: async ({ id, token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.delete('/usuarios/' + id, { headers });
    return {
      data: response
    }
  },

  //--------------Infos Sistemas
  info: async ({ token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.get('/infos-sistema', { headers });
    return { data: response.data }
  },
  infoPedidos: async ({ token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.get('/pedidos-pendentes', { headers });
    return { data: response.data }
  },
});